import { snmpPacketSchema } from 'shared/types'
import { paginationSchema } from 'utils/paginationSchema'
import { api } from '..'
import { usePaginatedQuery } from 'hooks/usePaginatedQuery'

export type TSnmpPacketFilters = Partial<{
  deviceId: string
  devAdr: string
}>

export type TSnmpPacketList = Awaited<ReturnType<typeof getSnmpPacketList>>
export type TSnmpPacket = TSnmpPacketList['items'][number]
export const getSnmpPacketList = async (filters?: TSnmpPacketFilters) => {
  const { items, ...data } = await api
    .get('/v1/snmp/packets', {
      params: filters,
    })
    .then(({ data }) => paginationSchema(snmpPacketSchema).parse(data))

  const newItems = items.flatMap(({ variables, ...item }) =>
    variables.map(variable => ({ ...item, ...variable })),
  )

  return { ...data, items: newItems }
}

export const SnmpPacketListQuery = (filters?: TSnmpPacketFilters) => ({
  queryFn: () => getSnmpPacketList(filters),
  queryKey: ['snmpPackets', filters],
  refetchOnWindowFocus: true,
})

export const useGetSnmpPackets = (manualFilters?: TSnmpPacketFilters) =>
  usePaginatedQuery(SnmpPacketListQuery, manualFilters)
